// import { instance, instanceEndUser } from "./service/instance";
import { apiSlice } from '../api/apiSlice'

  export const maskingPolicyApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getMaskingPolicyList: builder.query<any, any>({
            query: params => {
                return {
                    url: `/mask/policy`,
                    params: params
                }
            },
            providesTags:['GetMaskingPolicyList'],
        }),
        getMaskPolicyDetail: builder.query<any, any>({
            query: params => {
                return {
                    url: `/mask/policy/${params}`,
                }
            },
            providesTags:['GetMaskPolicyDetail'],
        }),
        createMaskPolicy: builder.mutation<any, any>({
            query: body => {
                return ({
                    url: `/mask/policy`,
                    method: 'POST',
                    body

                })
            },
            invalidatesTags:['CreateMaskingPolicy', 'GetMaskingPolicyList']
        }),
        deleteMaskPolicy: builder.mutation<any, any>({
            query: params => {
                return ({
                    url: `/mask/policy/${params}`,
                    method: 'DELETE',
                })
            },
            invalidatesTags:['DeleteMaskingPolicy', 'GetMaskingPolicyList']
        })
  })
})

export const {
useGetMaskingPolicyListQuery,
useGetMaskPolicyDetailQuery,
useDeleteMaskPolicyMutation,
useCreateMaskPolicyMutation
} = maskingPolicyApiSlice;